export default {
  incrementButton: { padding: '5px 5px', fontSize: 23 + 'px', backgroundColor: '#dec3cf', width: '28px' }
  ,decrementButton: { padding: '5px 8px', fontSize: 23 + 'px', backgroundColor: '#dec3cf' }
}